import Image from "next/image"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { NavigationItem } from "types/navigation"

export default function PromoCards({
  items,
  title,
}: {
  items: NavigationItem[]
  title?: string
}) {
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-bold text-brand-navy uppercase tracking-wide mb-2 pb-1 border-b border-gray-200">
          {title}
        </h3>
      )}
      <div className="flex gap-3">
        {items.map((item) => (
          <LocalizedClientLink
            key={item.id}
            href={item.url}
            className="group flex-shrink-0 rounded-lg overflow-hidden"
          >
            {item.image_url ? (
              <div className="relative w-[180px] h-[140px] overflow-hidden rounded-lg">
                <Image
                  src={item.image_url}
                  alt={item.label}
                  width={180}
                  height={140}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/80 via-brand-navy/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 px-2.5 pb-2">
                  <span className="text-white text-[13px] font-bold leading-tight block">
                    {item.label}
                  </span>
                </div>
              </div>
            ) : (
              <div className="w-[180px] h-[140px] bg-brand-navy rounded-lg flex flex-col items-center justify-center text-center px-3 group-hover:bg-brand-primary-dark transition-colors duration-200">
                <span className="text-white text-[13px] font-bold leading-tight">
                  {item.label}
                </span>
              </div>
            )}
            {item.image_subtitle && (
              <p className="text-[11px] text-gray-500 mt-1 text-center">
                {item.image_subtitle}
              </p>
            )}
          </LocalizedClientLink>
        ))}
      </div>
    </div>
  )
}
